import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../client.js';

export interface Unsicherheiten {
  bekannte_unbekannte: string;
  kritische_annahmen: string;
  klaerungsstrategie: string;
}

export interface UseUnsicherheitenResult {
  data: Unsicherheiten;
  isLoading: boolean;
  save: (patch: Partial<Unsicherheiten>) => Promise<void>;
}

const KEY = (pid: string) => ['projects', pid, 'uncertainties'] as const;

const DEFAULT_DATA: Unsicherheiten = {
  bekannte_unbekannte: '',
  kritische_annahmen: '',
  klaerungsstrategie: '',
};

export function useUnsicherheiten(projectId: string | undefined): UseUnsicherheitenResult {
  const qc = useQueryClient();

  const query = useQuery({
    queryKey: KEY(projectId ?? ''),
    queryFn: () => apiClient.get<Unsicherheiten>(`/api/v1/projects/${projectId}/uncertainties`),
    enabled: !!projectId,
  });

  const mutation = useMutation({
    mutationFn: (patch: Partial<Unsicherheiten>) =>
      apiClient.patch<Unsicherheiten>(`/api/v1/projects/${projectId}/uncertainties`, patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(projectId ?? '') }),
  });

  return {
    data: query.data?.data ?? DEFAULT_DATA,
    isLoading: query.isLoading,
    save: async (patch: Partial<Unsicherheiten>) => {
      await mutation.mutateAsync(patch);
    },
  };
}
